import { render, staticRenderFns } from "./forSaleVehicleList.vue?vue&type=template&id=00d53efc&scoped=true&"
import script from "./forSaleVehicleList.vue?vue&type=script&lang=js&"
export * from "./forSaleVehicleList.vue?vue&type=script&lang=js&"
import style0 from "./forSaleVehicleList.vue?vue&type=style&index=0&id=00d53efc&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00d53efc",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAlert } from 'vuetify/lib/components/VAlert';
import { VContainer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VAlert,VContainer})
